/**
 * UI-тексты виджетов страницы страны (Country widgets):
 *   - GfRegionExplorer (#scenarios / #compare region explorer)
 *   - GfCitiesGrid (поиск + чипы регионов + сетка городов)
 *   - GfPromoCodes (карточки промокодов с reveal/copy)
 *   - CountryFAQ (аккордеон вопросов)
 *
 * Только специфика этих компонентов; общие надзаголовки/якоря/теги — в servicePage.
 * Интерполируемые строки (aria с именем страны) — функции; склонение делает
 * компонент и передаёт сюда уже готовое слово.
 */
export const countryWidgetsUi = {
    en: {
        // GfRegionExplorer — #scenarios (region cards)
        scenarios: {
            eyebrow: 'Where to go',
            tag: 'by region',
            title: 'Destinations by region',
            lead: 'Pick the region that suits you — the card opens its cities in the comparison below.',
            go: 'View cities',
        },
        // GfRegionExplorer — #compare (cities ledger)
        compare: {
            eyebrow: 'Compare',
            title: 'Compare cities by region and season',
            lead: 'Filter by region and sort by season to quickly pick a destination.',
        },
        // GfCitiesGrid — search / region chips / grid
        cities: {
            all: 'All',
            search: 'Search cities and places…',
            searchLabel: 'Search cities',
            regions: 'Regions',
            empty: 'Nothing found — try another query or region.',
        },
        // GfPromoCodes — reveal/copy actions
        promo: {
            copy: 'Copy',
            copied: 'Copied',
            show: 'Show code',
            use: 'Use promo',
            validUntil: 'Valid until: ',
        },
        // CountryFAQ — eyebrow / heading / aria
        faq: {
            eyebrow: 'FAQ',
            heading: 'Common Questions',
            aria: (countryName) => `FAQ about ${countryName}`,
        },
    },
    ru: {
        scenarios: {
            eyebrow: 'Куда поехать',
            tag: 'по регионам',
            title: 'Направления по регионам страны',
            lead: 'Выберите регион, который вам ближе — карточка откроет подходящие города в сравнении ниже.',
            go: 'Смотреть города',
        },
        compare: {
            eyebrow: 'Сравнение',
            title: 'Сравните города по региону и сезону',
            lead: 'Отфильтруйте по региону и отсортируйте по сезону, чтобы быстро выбрать направление.',
        },
        cities: {
            all: 'Все',
            search: 'Поиск по городам и местам…',
            searchLabel: 'Поиск по городам',
            regions: 'Регионы',
            empty: 'Ничего не найдено — измените запрос или регион.',
        },
        promo: {
            copy: 'Копировать',
            copied: 'Скопировано',
            show: 'Показать код',
            use: 'Использовать',
            validUntil: 'Действует до: ',
        },
        faq: {
            eyebrow: 'Вопросы и ответы',
            heading: 'Популярные вопросы',
            aria: (countryName) => `Частые вопросы о ${countryName}`,
        },
    },
};
